export default __webpack_public_path__ + "static/media/patrimonio.ab83b3dd.svg";